import React from 'react';
import { Link } from 'react-router-dom';

import Menu from '../Menu';

import logo from '../../assets/logo.svg';

import { Container } from './styles';

const Header: React.FC = () => (
  <Container>
    <Menu />
    <Link to="/">
      <img src={logo} alt="MNZS - Front-End Developer" />
    </Link>
  </Container>
);

export default Header;
